import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const OutroValorContainer = styled(Box)`
    display: flex;
    padding: 1rem;
    flex-direction: column;
    gap: 0.5rem;
`